"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OidcHandler = void 0;
var oidc_client_ts_1 = require("oidc-client-ts");
var config_1 = require("../config");
var tracking_1 = require("../helpers/tracking");
var abstractHandler_1 = require("./abstractHandler");
var OidcHandler = /** @class */ (function (_super) {
    __extends(OidcHandler, _super);
    function OidcHandler(config) {
        var _a, _b, _c;
        var _this = _super.call(this, __assign(__assign({}, config), { tokenExpiredCallback: function () { return _this.publishAuthenticate({ loggedIn: false, isManualLogin: false }); }, userLoadedCallback: function (token) { return _this.publishTokenRenew(token); } })) || this;
        _this._oidcClientConfig = OidcHandler.generateOidcClientConfig(__assign(__assign(__assign({}, config_1.DEFAULTS), _this.config), { claims: __assign(__assign({}, (_a = _this.config) === null || _a === void 0 ? void 0 : _a.claims), { userinfo: __assign({ tracking_id: null, cumulus_connected: null }, (_c = (_b = _this.config) === null || _b === void 0 ? void 0 : _b.claims) === null || _c === void 0 ? void 0 : _c.userinfo) }) }));
        _this._userManager = new oidc_client_ts_1.UserManager(_this._oidcClientConfig);
        return _this;
    }
    OidcHandler.isNotMigrosDomainAnd3rdPartyCookiesDisabled = function () {
        return !window.location.href.includes('.migros.ch');
    };
    OidcHandler.isOIDCHash = function (hash) {
        return !!hash && (hash.indexOf('id_token') !== -1 || hash.indexOf('error') !== -1);
    };
    OidcHandler.isOIDCSearch = function (search) {
        return !!search && (search.indexOf('code=') !== -1 || search.indexOf('error=') !== -1);
    };
    OidcHandler.isInIFrame = function () {
        try {
            return window.frameElement !== null;
        }
        catch (err1) {
            try {
                return window.self !== window.top;
            }
            catch (err2) {
                return false;
            }
        }
    };
    OidcHandler.generateOidcClientConfig = function (config) {
        return {
            authority: config.authority,
            client_id: config.clientId,
            client_secret: config.clientSecret,
            redirect_uri: config.redirectURI,
            silent_redirect_uri: config.silentRedirectURI || config.redirectURI,
            response_type: config.responseType,
            scope: config.scope,
            post_logout_redirect_uri: config.redirectURI,
            loadUserInfo: true,
            extraQueryParams: { claims: JSON.stringify(config.claims) },
            automaticSilentRenew: true,
            includeIdTokenInSilentRenew: config.includeIdTokenInSilentRenew,
            ui_locales: config.language,
        };
    };
    OidcHandler.errorNeedsUserInteraction = function (err) {
        return err.error === 'interaction_required' || err.error === 'consent_required';
    };
    Object.defineProperty(OidcHandler.prototype, "userManager", {
        get: function () {
            return this._userManager;
        },
        enumerable: false,
        configurable: true
    });
    OidcHandler.prototype.login = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // ensure user is cleared so after redirect back we'll start fresh.
                        sessionStorage.removeItem(config_1.AUTHENTICATION_CONTEXT_ID);
                        return [4 /*yield*/, this.removeUser()];
                    case 1:
                        _a.sent();
                        if (this.config.loginUrl) {
                            window.location.href = this.config.loginUrl;
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.signinRedirect()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OidcHandler.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sessionStorage.removeItem(config_1.AUTHENTICATION_CONTEXT_ID);
                        return [4 /*yield*/, this.signoutRedirect()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OidcHandler.prototype.autologin = function () {
        return __awaiter(this, arguments, void 0, function (forceUserReload) {
            var isManualLogin, loggedIn, trackingId, hasCumulusConnected, profile, mtid;
            if (forceUserReload === void 0) { forceUserReload = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isManualLogin = false;
                        loggedIn = false;
                        trackingId = undefined;
                        hasCumulusConnected = false;
                        return [4 /*yield*/, this._autologin(forceUserReload)];
                    case 1:
                        isManualLogin = _a.sent();
                        return [4 /*yield*/, this.isLoggedIn()];
                    case 2:
                        loggedIn = _a.sent();
                        return [4 /*yield*/, this.getUser()];
                    case 3:
                        profile = _a.sent();
                        trackingId = typeof (profile === null || profile === void 0 ? void 0 : profile.tracking_id) === 'string' ? profile === null || profile === void 0 ? void 0 : profile.tracking_id : undefined;
                        hasCumulusConnected = typeof (profile === null || profile === void 0 ? void 0 : profile.cumulus_connected) === 'boolean' ? profile === null || profile === void 0 ? void 0 : profile.cumulus_connected : false;
                        loggedIn && (0, tracking_1.trackLogin)(isManualLogin);
                        // save MTID (Migros Tracking ID) and track user, even if the user logged out
                        trackingId && localStorage.setItem(config_1.MTID, trackingId);
                        mtid = localStorage.getItem(config_1.MTID);
                        mtid && (0, tracking_1.trackUser)(mtid, hasCumulusConnected);
                        this.publishAuthenticate({
                            loggedIn: loggedIn,
                            isManualLogin: isManualLogin,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    OidcHandler.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.userManager.getUser()];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, user ? user.access_token : ''];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/, ''];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OidcHandler.prototype.isLoggedIn = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.userManager.getUser()];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, user !== null];
                    case 2:
                        e_2 = _a.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OidcHandler.prototype.removeUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userManager.removeUser()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OidcHandler.prototype.signinRedirect = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userManager.signinRedirect()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OidcHandler.prototype.signoutRedirect = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userManager.signoutRedirect()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OidcHandler.prototype.getUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.userManager.getUser()];
                    case 1: return [2 /*return*/, (_b = (_a = (_c.sent())) === null || _a === void 0 ? void 0 : _a.profile) !== null && _b !== void 0 ? _b : null];
                }
            });
        });
    };
    OidcHandler.prototype.clearStaleState = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userManager.clearStaleState()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    OidcHandler.prototype.triggerLoggedInEvent = function (returnToURL, willRedirect) {
        var shouldTriggerLoggedInEvent = false;
        if (!returnToURL || !willRedirect) {
            shouldTriggerLoggedInEvent = this.checkIsManualLoginUsingCookie();
        }
        return shouldTriggerLoggedInEvent;
    };
    OidcHandler.prototype._autologin = function () {
        return __awaiter(this, arguments, void 0, function (forceUserReload) {
            var returnToURL, willRedirect, shouldTriggerLoggedInEvent, err_1;
            var _this = this;
            if (forceUserReload === void 0) { forceUserReload = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.userManager.events.addAccessTokenExpired(this.config.tokenExpiredCallback);
                        this.userManager.events.addUserLoaded(function (user) { return _this.config.userLoadedCallback(user.access_token); });
                        this.userManager.events.addSilentRenewError(function (err) {
                            console.error('Unable to renew access token', err);
                            _this.config.tokenExpiredCallback();
                        });
                        returnToURL = localStorage.getItem(config_1.MSC_OIDC_RETURN_TO);
                        willRedirect = window.location.href !== returnToURL &&
                            (window.location.href.includes(this.config.redirectURI) ||
                                window.location.href.includes(this.config.silentRedirectURI));
                        shouldTriggerLoggedInEvent = this.triggerLoggedInEvent(returnToURL, willRedirect);
                        return [4 /*yield*/, this.handleOIDCState(forceUserReload)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 3, , 5]);
                        if (returnToURL) {
                            localStorage.removeItem(config_1.MSC_OIDC_RETURN_TO);
                            // don't do an unnecessary redirect if URL is the same.
                            if (willRedirect) {
                                window.location.href = returnToURL;
                            }
                            return [2 /*return*/, shouldTriggerLoggedInEvent];
                        }
                        return [2 /*return*/, shouldTriggerLoggedInEvent];
                    case 3:
                        err_1 = _a.sent();
                        return [4 /*yield*/, this.userManager.removeUser()];
                    case 4:
                        _a.sent();
                        console.error('Error during OIDC autologin when setting up user', err_1);
                        return [2 /*return*/, shouldTriggerLoggedInEvent];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    OidcHandler.prototype.isOnRedirectUri = function () {
        return window.location.href.includes(this.config.redirectURI);
    };
    OidcHandler.prototype.isAuthenticated = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, data, acid, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, , 7]);
                        if (OidcHandler.isNotMigrosDomainAnd3rdPartyCookiesDisabled()) {
                            return [2 /*return*/, !!localStorage.getItem(config_1.AUTO_LOGIN_TIMESTAMP_COOKIE)];
                        }
                        return [4 /*yield*/, fetch("".concat(this._oidcClientConfig.authority, "/api/authenticationcontext"), {
                                headers: {
                                    Accept: 'application/json',
                                },
                                credentials: 'include',
                            })];
                    case 1:
                        result = _a.sent();
                        return [4 /*yield*/, result.json()];
                    case 2:
                        data = (_a.sent());
                        acid = sessionStorage.getItem(config_1.AUTHENTICATION_CONTEXT_ID);
                        if (!(data.authenticated && acid && acid !== data.acid)) return [3 /*break*/, 5];
                        // ACID changed so probably the user changed as well, initiate a new autologin
                        return [4 /*yield*/, this.userManager.removeUser()];
                    case 3:
                        // ACID changed so probably the user changed as well, initiate a new autologin
                        _a.sent();
                        sessionStorage.setItem(config_1.AUTHENTICATION_CONTEXT_ID, data.acid);
                        return [4 /*yield*/, this.autologin()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        sessionStorage.setItem(config_1.AUTHENTICATION_CONTEXT_ID, data.acid);
                        return [2 /*return*/, data.authenticated];
                    case 6:
                        e_3 = _a.sent();
                        console.error('Error fetching loginstatus', e_3);
                        return [2 /*return*/, false];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    OidcHandler.prototype.handleOIDCState = function () {
        return __awaiter(this, arguments, void 0, function (forceUserReload) {
            var user, hash, search, authenticated, err_2;
            var _a;
            if (forceUserReload === void 0) { forceUserReload = false; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        user = null;
                        if (!(forceUserReload && !OidcHandler.isNotMigrosDomainAnd3rdPartyCookiesDisabled())) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.userManager.removeUser()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 16, , 19]);
                        hash = window.location.hash;
                        search = window.location.search;
                        if (!(this.isOnRedirectUri() && (OidcHandler.isOIDCHash(hash) || OidcHandler.isOIDCSearch(search)))) return [3 /*break*/, 6];
                        if (search && search.includes('error=') && search.includes('interaction_required')) {
                            localStorage.removeItem(config_1.AUTO_LOGIN_TIMESTAMP_COOKIE);
                        }
                        if (!OidcHandler.isInIFrame()) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.userManager.signinSilentCallback()];
                    case 3:
                        _b.sent();
                        // because we're in an iframe, we're not interested in the user anyway -> return null is ok.
                        return [2 /*return*/, null];
                    case 4: return [4 /*yield*/, this.userManager.signinRedirectCallback()];
                    case 5:
                        user = _b.sent();
                        if (user) {
                            localStorage.setItem(config_1.AUTO_LOGIN_TIMESTAMP_COOKIE, Date.now().toString());
                        }
                        else {
                            localStorage.removeItem(config_1.AUTO_LOGIN_TIMESTAMP_COOKIE);
                        }
                        // remove hash part from current location
                        // (just setting window.location.hash to empty string keeps the hash sign in URL)
                        history.replaceState(null, '', ' ');
                        return [3 /*break*/, 15];
                    case 6: return [4 /*yield*/, this.isAuthenticated()];
                    case 7:
                        authenticated = _b.sent();
                        if (!!authenticated) return [3 /*break*/, 9];
                        sessionStorage.removeItem(config_1.AUTHENTICATION_CONTEXT_ID);
                        return [4 /*yield*/, this.userManager.removeUser()];
                    case 8:
                        _b.sent();
                        return [2 /*return*/, null];
                    case 9: return [4 /*yield*/, this.userManager.getUser()];
                    case 10:
                        // already an existing user/access token in session storage?
                        user = _b.sent();
                        // if token in session storage is expired, reset user to null. This will try an iFrame login.
                        if (user && user.expired) {
                            user = null;
                        }
                        if (!!user) return [3 /*break*/, 15];
                        if (!OidcHandler.isNotMigrosDomainAnd3rdPartyCookiesDisabled()) return [3 /*break*/, 12];
                        localStorage.setItem(config_1.MSC_OIDC_RETURN_TO, window.location.href);
                        return [4 /*yield*/, this.userManager.signinRedirect({ prompt: 'none' })];
                    case 11:
                        _b.sent();
                        return [2 /*return*/, null];
                    case 12: 
                    // signinSilent is using an iFrame to retrieve token and user information.
                    return [4 /*yield*/, this.userManager.signinSilent()];
                    case 13:
                        // signinSilent is using an iFrame to retrieve token and user information.
                        _b.sent();
                        return [4 /*yield*/, this.userManager.getUser()];
                    case 14:
                        user = _b.sent();
                        _b.label = 15;
                    case 15: return [3 /*break*/, 19];
                    case 16:
                        err_2 = _b.sent();
                        if (!!OidcHandler.errorNeedsUserInteraction(err_2)) return [3 /*break*/, 18];
                        localStorage.removeItem(config_1.AUTO_LOGIN_TIMESTAMP_COOKIE);
                        return [4 /*yield*/, ((_a = this.userManager) === null || _a === void 0 ? void 0 : _a.removeUser())];
                    case 17:
                        _b.sent();
                        console.error('Error during OIDC autologin', err_2);
                        return [2 /*return*/, null];
                    case 18: return [3 /*break*/, 19];
                    case 19: return [2 /*return*/, user];
                }
            });
        });
    };
    return OidcHandler;
}(abstractHandler_1.AbstractHandler));
exports.OidcHandler = OidcHandler;
